 <template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="main-symptom-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device
                        :shortcut-nav="this.shortcutNav"
                        @setIsKeyboardNav="setIsKeyboardNav"
                        :title="text('api.mainsymptomTitle')" ref="headerMedical"></header-bar-medical-device>
                </v-flex>
            </v-layout>

            <div class="scrolling-content scrolling-main-symptom-page padding-left-xxl padding-right-xxl"
                 ref="mainSymptomScrollingContentRef" >
                <v-layout row wrap class="general-info page-content with-alerts ">
                    <v-flex xs12 sm5 md5 lg3 class="no-padding-top">
                        <chapters :shortcutNav="this.shortcutNav"
                                  ref="chaptersRef"
                                  :class="{'panel-main-symptom-highlighted': this.shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'CHAPTER'}"
                                  >
                        </chapters>
                    </v-flex>

                    <v-flex xs12 sm7 md7 lg9 class="choose-symptoms-section no-padding-top">
                        <symptoms :chooseSymptomChapter="chooseSymptomChapter"
                                  ref="symptomsRef"
                                  :shortcutNav="this.shortcutNav"
                                  @isSearchSymptomResultList="navFocusOnSearchSymptom"
                                  class="margin-left-xs padding-right-xs">
                        </symptoms>
                    </v-flex>

                </v-layout>
            </div>
        </v-container>

        <v-footer app class="elevation-bg-color border-top-invisible">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">
                <v-flex xs12 text-xs-center>
                    <v-btn @click="gotoScoringPage()"
                           id="btnFinishAssessment"
                           class="footer-btn goToScoring "
                           :class="{'is-semi-target': isSemiTarget}"
                           flat
                    >
                        {{text('api.button.finish')}}
                        <finish-icon />
                    </v-btn>

                    <div class="footer-right-btns">
                        <v-btn flat @click="goToPreviousPage" id="btnGoToPrevAssessmentPage" class="footer-btn">
                            <arrow-left-icon />
                            {{ text('api.button.back') }}
                        </v-btn>
                        <v-btn color="primary"
                               @click="goToNextPage"
                               :disabled="!isMainSymptomSelected"
                               id="btnGoToNextAssessmentPage"
                               class="footer-btn footer-btn-next color-on-primary-text"
                               :class="{'is-semi-target grey--text text--darken-1': isMainSymptomSelected && isSemiTarget}"
                        >
                            {{ text('api.button.next') }}
                            <arrow-next-icon :svg-fill-class="'svg-on-primary-color'"/>
                        </v-btn>
                    </div>

                </v-flex>
            </v-layout>
        </v-footer>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>

        <div v-if="getMustShowVitalParamsForm" class="vital-params-form-overlay overlay overlay--active"></div>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import HeaderBar from "../shared/HeaderBar";
    import TopBar from '../../../common/components/shared/TopBar';
    import Chapters from "./Chapters";
    import Symptoms from "./Symptoms";
    import AssessmentAlerts from "../../../common/components/shared/AssessmentAlerts";
    import PatientInfo from "../../../common/components/shared/PatientInfo";
    import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
    import HeaderBarMedicalDevice from "../shared/HeaderBarMedicalDevice";
    import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
    import FinishIcon from "../../../common/components/svg/shared/finishIcon";
    import ArrowLeftIcon from "../../../common/components/svg/shared/arrowLeftIcon";
    import ArrowNextIcon from "../../../common/components/svg/shared/arrowNextIcon";

    const CMS_PANEL = {
        CHAPTER: "CHAPTER",
        SUBCHAPTER: "SUBCHAPTER",
        SYMPTOM: "SYMPTOM",
        SEARCH: "SEARCH",
    };

    export default {
        name: 'ChooseMainSymptomPage',

        components: {
            ArrowNextIcon,
            ArrowLeftIcon,
            FinishIcon,
            Chapters,
            Symptoms,
            HeaderBar,
            TopBar,
            AssessmentAlerts,
            PatientInfo,
            AcceptCookie,
            HeaderBarMedicalDevice,
            DetectBrowserCookie
        },

        beforeCreate() {
            if (typeof this.$route.query.referral === "undefined" || this.$route.query.referral !== "testsTreeNode") {
                this.$store.commit('ChooseMainSymptomStore/resetStore');
                this.$store.commit('AssessmentAlertsStore/resetStore');
            }
        },

        created() {
            // If the url has param ?referral=testsTreeNode, that means that we are coming from tests tree,
            // so data for this page should be already loaded and must be kept and used.
            // Otherwise, (re)load data now.
            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsTreeNode") {
                this.$router.replace({'referral': null});
            } else {
                this.$store.dispatch("ChooseMainSymptomStore/loadChapterTree");
            }

            window.addEventListener('keydown', this.handleKeyDowns);
            window.addEventListener('keyup', this.handleKeyUps);
            window.addEventListener('mousedown', this.handleMouseDown);
            window.addEventListener('contextmenu', this.handleRightClick);
            window.addEventListener('click', this.handleClick);
        },

        destroyed() {
            window.removeEventListener('keydown', this.handleKeyDowns);
            window.removeEventListener('keyup', this.handleKeyUps);
            window.removeEventListener('mousedown', this.handleMouseDown);
            window.removeEventListener('contextmenu', this.handleRightClick);
            window.removeEventListener('click', this.handleClick);
        },

        data() {
            return {
                chooseSymptomChapter: [],
                tempPatientComment: "",

                shortcutNav: {

                    isKeyboardNav: false,
                    isPanelHighlight: false,

                    crtPanel: CMS_PANEL.CHAPTER,

                    crtChapter: null,
                    crtSubchapter: null,
                    crtSymptom: null
                },

                isKeyDown: {},
            }
        },

        computed: {
            ...mapGetters({
                isMainSymptomSelected: 'ChooseMainSymptomStore/isMainSymptomSelected',
                getChapterTree: 'ChooseMainSymptomStore/getChapterTree',
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
                medicalStatuses: 'AssessmentAlertsStore/getMedicalStatuses',
                medicalStatus: 'AssessmentAlertsStore/getMedicalStatus',

                getActiveChapter: 'ChooseMainSymptomStore/getActiveChapter',
                getHasSubchapters: 'ChooseMainSymptomStore/getHasSubchapters',
                getSearchSymptomResultList: 'ChooseMainSymptomStore/getSearchSymptomResultList',
                getSelectedMainSymptomCode: 'ChooseMainSymptomStore/getSelectedMainSymptomCode',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
                mustShowVitalParametersForm: 'VitalParametersStore/getMustShowVitalParamsForm',
                getSemiTarget: 'AssessmentAlertsStore/getSemiTarget',
                getShowUserComment: 'TranslationStore/getShowUserComment',
                getShowUserCommentShortcut: 'TranslationStore/getShowUserCommentShortcut',
                getShowUserCommentNoShortcut: 'TranslationStore/getShowUserCommentNoShortcut',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',

            }),

            symptomId() {
                return this.$store.state["ChooseMainSymptomStore"].selectedMainSymptomId;
            },

            isSemiTarget () {
                // I created a computed method to be useful if we will need to add a more complex condition
                // in order to visually mark the semiTarget attribute in the page (ex. buttons colors).
                return ((this.getSemiTarget === true) ? true : false);
            }
        },

        watch: {

            mustShowScoringPopup(newValue) {

                this.navSetFocusAndScrollToElement(newValue);
            },

            getShowUserComment(newValue) {
                this.navSetFocusAndScrollToElement(newValue);
            }
        },

        methods: {
            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            }),

            setTemporaryPatientCommentValue() {
                this.tempPatientComment = this.patientProfileData.comment;

                // Place cursor at the end of the patient comment text
                let commentId = document.getElementById("comment");
                if (commentId != null) {

                    let commentLength = commentId.value.length;
                    commentId.selectionStart = commentLength;
                    commentId.selectionEnd = commentLength;
                }
            },

            isPatientCommentChanged() {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },

            savePatientComment: function () {
                if (this.$refs.headerMedical.isPatientCommentChanged() && this.getShowUserCommentShortcut) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientProfileComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
                this.showComment = false;
                this.$store.commit('TranslationStore/setShowUserComment', this.showComment);
                this.$store.commit('TranslationStore/setShowUserCommentShortcut', this.showComment);
            },

            goToPreviousPage() {
                if(!this.getMustShowAssessmentList) {
                    this.$router.push('/assessment-start');
                } else {
                    this.$router.push('/assessment-start-list');
                }
            },

            goToNextPage() {
                if (this.isMainSymptomSelected) {
                    if (!this.getMustShowAssessmentList) {
                        // Go to Choose Main Symptom page.
                        this.$router.push('/symptoms-questions');
                    }
                    else {
                        this.$router.push('/symptoms-list');
                    }
                }
            },

            gotoScoringPage() {
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                    shortcutUsed: true
                });
                promiseEvaluateAssessment.then(() => {
                    // SMASSDEV - 1044.
                    // We need to reset the store when the user presses the finish button
                    // If the user presses on the radio button for the main symptom and then on the finish button
                    // we don't need to save in store the main symptom.
                    this.$store.commit('ChooseMainSymptomStore/resetStore');

                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            },

            patientCommentFocus() {

               this.$store.commit('TranslationStore/setShowUserComment', true);
                this.$store.commit('TranslationStore/setShowUserCommentShortcut', true);

            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            setIsKeyboardNav(value) {
                this.shortcutNav.isKeyboardNav = value;
            },

            handleKeyDowns(event) {
                if (this.mustShowVitalParametersForm === true) {
                    return;
                }

                switch (event.keyCode) {

                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // PageUp
                    case 33:
                        // Disable input search behaviour for IE11 (put caret on first position)
                        event.preventDefault();

                        if (this.mustShowScoringPopup === true || this.getShowUserComment === true || this.mustShowInfoPopup === true) {
                            return;
                        }

                        // Scroll Up
                        if (this.$refs["mainSymptomScrollingContentRef"] != null) {
                            this.$refs["mainSymptomScrollingContentRef"].scrollTop -= 50;
                        }
                        break;

                    // PageDown
                    case 34:
                        // Disable input search behaviour for IE11 (put caret on last position)
                        event.preventDefault();

                        if (this.mustShowScoringPopup === true || this.getShowUserComment === true || this.mustShowInfoPopup === true) {
                            return;
                        }

                        // Scroll Down
                        if (this.$refs["mainSymptomScrollingContentRef"] != null) {
                            this.$refs["mainSymptomScrollingContentRef"].scrollTop += 50;
                        }
                        break;
                    // V
                    case 86:
                        // ALT + V
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // Prevent the default behavior
                            event.preventDefault();


                            // If the scoring popup is shown, then close it
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            // If the info popup is shown, then close it
                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }


                            // If we have a field in edit, then exit editing
                            if (this.shortcutNav.isFieldInEdit === true) {
                                this.shortcutNav.isFieldInEdit = false;
                            }

                            // Open the dropdown for the vital parameters
                            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);

                            // Enable keyboard navigation
                            this.shortcutNav.isKeyboardNav = true;
                        }

                        break;
                }

                //Prevent repeated calls for certain keys
                if (this.isKeyDown[event.keyCode] === true) {
                    return;
                }
                this.isKeyDown[event.keyCode] = true;
                switch (event.keyCode) {

                    // TAB
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // ESCAPE
                    case 27:
                        // ESCAPE -> close patient comment and TAO
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            if (this.getShowUserComment) {
                                this.savePatientComment();
                            }
                        }
                        break;

                    // M
                    case 77:
                        // ALT + M -> open patient comment
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            event.preventDefault();

                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }

                            this.$store.commit('TranslationStore/setShowUserCommentNoShortcut', false);

                            this.patientCommentFocus();
                        }
                        break;

                    // P
                    case 80:
                        // ALT + P -> open TAO
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {

                            if (this.medicalStatus === this.medicalStatuses.INFORMATION
                                || this.medicalStatus === this.medicalStatuses.URGENT) {

                                event.preventDefault();

                                if (this.mustShowInfoPopup === true) {
                                    this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                                }

                                if (this.getShowUserComment === true) {
                                    this.savePatientComment();
                                }

                                this.showScoringPopup();
                            }

                        }
                        break;

                }

                if (this.mustShowScoringPopup === true || this.getShowUserComment === true || this.mustShowInfoPopup === true ) {
                    return;
                }

                // when pressing a letter (A to Z) scroll up to search field and highlight first symptom from search result if not empty
                if (event.keyCode >= 65 && event.keyCode <= 90) {
                    // The key Shift can be true or false (lower or upper case letters)
                    if (event.altKey === false && event.ctrlKey === false) {
                        this.navDisablePanelHighlight();
                        this.navSetFocusOnSearchInput();
                        return;
                    }
                }

                // small screen
                let xsOnly = this.$vuetify.breakpoint.xsOnly;

                switch (event.keyCode) {

                    // Enter
                    case 13:
                        // Enter
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            if (!this.shortcutNav.isKeyboardNav) {
                                return;
                            }

                            switch (this.shortcutNav.crtPanel) {

                                case CMS_PANEL.CHAPTER:
                                    if (this.shortcutNav.crtChapter !== null) {
                                        let chapterObj = null;
                                        this.getChapterTree.chapters.forEach((crtChapter) => {
                                            if (crtChapter.code === this.shortcutNav.crtChapter) {
                                                chapterObj = crtChapter;
                                            }
                                        });

                                        if (chapterObj !== null) {
                                            this.$store.dispatch('ChooseMainSymptomStore/resetSearchSymptom');
                                            this.$store.commit('ChooseMainSymptomStore/setActiveChapter', chapterObj);

                                            this.shortcutNav.crtSubchapter = null;
                                            this.shortcutNav.crtSymptom = null;
                                        }
                                        this.navScrollToTopChapterPanel();
                                    }
                                    break;

                                case CMS_PANEL.SYMPTOM:
                                    this.navSelectMainSymptom();
                                    break;

                                case CMS_PANEL.SEARCH:
                                    // if we don't have search result => don't select a symptom when press enter in input search
                                    if (this.getSearchSymptomResultList != null && this.getSearchSymptomResultList.length > 0
                                        && this.$refs["chaptersRef"] != null && this.$refs["chaptersRef"].searchSymptomInputValue !== "") {
                                        this.navSelectMainSymptom();
                                    }
                                    break;
                            }
                        }
                        break;

                    // Shift
                    case 16:
                        event.preventDefault();
                        this.navEnablePanelHighlight();

                        switch (this.shortcutNav.crtPanel) {

                            case CMS_PANEL.SYMPTOM:

                                // On Shift + Arrow Down/Up we need to change crtPanel to commute between subchapters panel
                                // so on Shift key down we change panel: Symptoms -> Subchapter
                                //and on Shift key up we change panel: Subchapter -> Symptoms
                                if (this.getHasSubchapters) {
                                    this.shortcutNav.crtPanel = CMS_PANEL.SUBCHAPTER;
                                    this.navScrollIntoViewSubchapterPanel()
                                }
                                else {
                                    // scroll up to the top of Symptom Panel
                                    this.navScrollIntoViewSymptomPanel();
                                }
                                break;

                            case CMS_PANEL.SEARCH:

                                // On Shift if the search result is empty or the search input value from search text field is empty string
                                // We highlight the Chapter Panel and select the first visible chapter
                                if (!this.getSearchSymptomResultList.length || (this.$refs["chaptersRef"] != null
                                    && this.$refs["chaptersRef"].searchSymptomInputValue === "")) {
                                    // move to Chapter Panel => search and set first visible chapter
                                    this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                                    this.navToFirstVisibleChapter();
                                }
                                else {
                                    // we are in search input and we pressed the shift and the current symptom is null => we need to select the first symptom
                                    if (this.shortcutNav.crtSymptom === null) {
                                        this.navToFirstSymptomSearch();
                                    }
                                    else {
                                        // current symptom is not null, pressed shift => scroll up to the top of Search Panel
                                        this.navScrollIntoViewSearchPanel();
                                    }
                                }
                                break;

                            case CMS_PANEL.CHAPTER:
                                // scroll up to the to of Chapter Panel
                                this.navScrollToTopChapterPanel();
                                break;

                            case CMS_PANEL.SUBCHAPTER:
                                this.navScrollIntoViewSubchapterPanel()
                                break;
                        }
                        break;

                    // PageUp
                    case 33:
                        // SHIFT + PageUp (BACK button)
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            if (this.$router.currentRoute.name=== 'ChooseMainSymptomPage') {
                                this.goToPreviousPage()
                            }
                        }
                        break;

                    // PageDown
                    case 34:
                        // SHIFT + PageDown (NEXT Button)
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            if (this.$router.currentRoute.name=== 'ChooseMainSymptomPage') {
                                this.goToNextPage();
                            }
                        }
                        break;

                    // End
                    case 35:
                        event.preventDefault();
                        // SHIFT + End (FINISH Button)
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            this.gotoScoringPage();
                        }
                        break;

                    // Home
                    case 36:
                        event.preventDefault();
                        // Shift + Home
                        if (event.ctrlKey === false && event.altKey === false && event.shiftKey === true) {
                            this.navGotoFirstPage();
                        }
                        break;

                    // ArrowLeft
                    case 37:
                        if (document.getElementById("inputSearchSymptomId") === null) {
                            event.preventDefault();
                        }
                        // SHIFT + LEFT
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            if (!xsOnly) {
                                this.navToNextOrLeftPanel(false, false);
                            }
                        }
                        // SHIFT + CTRL + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            if (!xsOnly ) {
                                this.navToNextOrLeftPanel(false, true);
                            }
                        }
                        break;

                    // ArrowUp
                    case 38:
                        event.preventDefault();
                        this.shortcutNav.isKeyboardNav = true;

                        // UP
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {

                                case CMS_PANEL.CHAPTER:
                                    this.navChapterUp();
                                    this.navScrollIntoViewChapterPanel();
                                    break;

                                case CMS_PANEL.SUBCHAPTER:
                                    this.shortcutNav.crtPanel = CMS_PANEL.SYMPTOM;
                                    this.navSymptomUp();
                                    break;

                                case CMS_PANEL.SYMPTOM:
                                    this.navSymptomUp();
                                    break;

                                case CMS_PANEL.SEARCH:
                                    this.navSymptomSearchUp();
                                    this.navScrollIntoSymptomsSearchPanel();
                                    break;
                            }
                        }
                        // CTRL + UP
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {

                                case CMS_PANEL.CHAPTER:
                                    this.navToFirstVisibleChapter();
                                    this.navScrollIntoViewChapterPanel();
                                    break;

                                // when using ArrowDown after click
                                case CMS_PANEL.SUBCHAPTER:
                                    this.shortcutNav.crtPanel = CMS_PANEL.SYMPTOM;
                                    this.navToFirstSymptom();
                                    break;

                                case CMS_PANEL.SYMPTOM:
                                    this.navToFirstSymptom();
                                    break;

                                case CMS_PANEL.SEARCH:
                                    this.navToFirstSymptomSearch();
                                    this.navScrollIntoSymptomsSearchPanel();
                                    break;
                            }
                        }
                        // SHIFT + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            if (xsOnly) {
                                this.shortcutNav.crtSymptom = null;
                                this.navToPreviousOrRightPanel(true, false);
                            }
                            else {
                                if (this.shortcutNav.crtPanel === CMS_PANEL.SUBCHAPTER) {
                                    this.shortcutNav.crtSymptom = null;
                                    this.navSubchapterUp(false);
                                }
                            }
                        }
                        // SHIFT + CTRL + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            if (xsOnly) {

                                if (this.shortcutNav.crtPanel === CMS_PANEL.SEARCH
                                    || this.shortcutNav.crtPanel === CMS_PANEL.SUBCHAPTER
                                    || (!this.getHasSubchapters && this.shortcutNav.crtPanel === CMS_PANEL.SYMPTOM)) {

                                    this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                                    this.navScrollToTopChapterPanel();
                                }
                            }
                            else {

                                if (this.shortcutNav.crtPanel === CMS_PANEL.SUBCHAPTER) {

                                    this.shortcutNav.crtSymptom = null;
                                    this.navToFirstSubchapter();
                                    this.navScrollIntoViewSubchapterPanel();
                                }
                            }
                        }
                        break;

                    // ArrowRight
                    case 39:

                        if (document.getElementById("inputSearchSymptomId") === null) {
                            event.preventDefault();
                        }

                        // SHIFT + RIGHT
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            if (!xsOnly) {
                                this.navToPreviousOrRightPanel(false, false);
                            }
                        }
                        // SHIFT + CTRL + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            if (!xsOnly) {
                                this.navToPreviousOrRightPanel(false, true);
                            }
                        }
                        break;

                    // ArrowDown
                    case 40:
                        event.preventDefault();
                        this.shortcutNav.isKeyboardNav = true;

                        // DOWN
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {

                                case CMS_PANEL.CHAPTER:
                                    this.navChapterDown();
                                    this.navScrollIntoViewChapterPanel();
                                    break;

                                // when using ArrowDown after click
                                case CMS_PANEL.SUBCHAPTER:
                                    this.shortcutNav.crtPanel = CMS_PANEL.SYMPTOM;
                                    this.navSymptomDown();
                                    break;

                                case CMS_PANEL.SYMPTOM:
                                    this.navSymptomDown();
                                    break;

                                case CMS_PANEL.SEARCH:
                                    this.navSymptomSearchDown();
                                    this.navScrollIntoSymptomsSearchPanel();
                                    break;
                            }
                        }
                        // CTRL + DOWN
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {

                                case CMS_PANEL.CHAPTER:
                                    this.navToLastVisibleChapter();
                                    this.navScrollIntoViewChapterPanel();
                                    break;

                                // when using ArrowDown after click
                                case CMS_PANEL.SUBCHAPTER:
                                    this.shortcutNav.crtPanel = CMS_PANEL.SYMPTOM;
                                    this.navToLastSymptom();
                                    break;

                                case CMS_PANEL.SYMPTOM:
                                    this.navToLastSymptom();
                                    break;

                                case CMS_PANEL.SEARCH:
                                    this.navToLastSymptomSearch();
                                    this.navScrollIntoSymptomsSearchPanel();
                                    break;
                            }
                        }
                        // SHIFT + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            if (xsOnly) {
                                this.shortcutNav.crtSymptom = null;
                                this.navToNextOrLeftPanel(true, false);
                            }
                            else {
                                if (this.shortcutNav.crtPanel === CMS_PANEL.SUBCHAPTER) {

                                    this.shortcutNav.crtSymptom = null;
                                    this.navSubchapterDown(false);
                                }
                            }
                        }
                        // SHIFT + CTRL + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {

                                case CMS_PANEL.CHAPTER:
                                    if (xsOnly) {
                                        this.navFromChapterToNextPanel(true, true, true);
                                    }
                                    break;

                                case CMS_PANEL.SUBCHAPTER:
                                    this.shortcutNav.crtSymptom = null;
                                    this.navToLastSubchapter();
                                    this.navScrollIntoViewSubchapterPanel();
                                    break;
                            }
                        }
                        break;

                    default:
                    // Do nothing, just ignore any unspecified keyDowns.
                }
            },

            handleKeyUps(event) {
                if (this.mustShowVitalParametersForm === true) {
                    return;
                }
                this.isKeyDown[event.keyCode] = false;

                switch (event.keyCode) {

                    // TAB
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Enter
                    case 13:
                        // CTRL + Enter
                        // Handled on keyUps because keyDowns doesn't handle CTRL + ENTER
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            if (this.getShowUserComment) {
                                this.savePatientComment();
                            }
                        }
                        break;
                }

                // if the scoring popup  and patient comment is open disable the page behaviour
                if (this.mustShowScoringPopup === true || this.getShowUserComment === true || this.mustShowInfoPopup === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Shift
                    case 16:
                        this.navDisablePanelHighlight();
                        this.navFocusPanelElement();
                        break;

                    default:
                    // Do nothing, just ignore any unspecified keyUps.
                }
            },

            handleMouseDown(event) {

                if (this.mustShowScoringPopup || this.mustShowVitalParametersForm === true) {
                    return;
                }

                event.preventDefault();
                event.stopImmediatePropagation();

                this.shortcutNav.isKeyboardNav = false;
                this.navDisablePanelHighlight();

                if (this.getShowUserComment) {
                    this.savePatientComment();
                    return;
                }

                // For IE 11 when click on scrollbar set focus on search
                let that = this;
               setTimeout(() => {
                   that.navSetFocusOnSearchInput();
               },0);

            },

            handleClick() {
                // when TAO popup is open and click outside the popup(click in page)
                this.shortcutNav.isKeyboardNav = false;
            },

            handleRightClick() {

                if (this.getShowUserComment || this.mustShowVitalParametersForm === true) {
                    return;
                }

                // For IE 11 and Edge when right click on the page blur search input, then focus and put cursor
                this.navSetBlurOnSearchInput();
                this.navSetFocusOnSearchInput();
            },

            onCommentMouseDn() {

                this.shortcutNav.isKeyboardNav = false;
                this.navDisablePanelHighlight();

                if (this.getShowUserComment) {
                    this.savePatientComment();
                }
                else {
                    this.getShowUserComment = true;
                }
            },

            onCommentBlockMouseDn(event) {

                if (this.$refs["comment"] != null && this.$refs["comment"].$refs.input.parentElement === event.target) {

                    this.shortcutNav.isKeyboardNav = false;
                    this.navDisablePanelHighlight();
                }
            },

            navEnablePanelHighlight() {

                this.shortcutNav.isKeyboardNav = true;
                this.shortcutNav.isPanelHighlight = true;
            },

            navDisablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = false;
            },

            navFocusPanelElement() {

                switch (this.shortcutNav.crtPanel) {

                    case CMS_PANEL.CHAPTER:
                        if (this.shortcutNav.crtChapter === null) {
                            this.navToFirstVisibleChapter();
                        }
                        else {
                            this.navScrollIntoViewChapterPanel();
                        }
                        break;

                    case CMS_PANEL.SUBCHAPTER:
                        this.shortcutNav.crtPanel = CMS_PANEL.SYMPTOM;

                        if (this.getActiveChapter && this.getHasSubchapters) {

                            let subchapterIdx = this.getActiveChapter.subChapters.findIndex((crtSubchapter) => {
                                return crtSubchapter.code === this.shortcutNav.crtSubchapter;
                            });

                            let mainSymptomInSubchapter = this.getActiveChapter.subChapters[subchapterIdx].symptoms.findIndex((symptom) => {
                                return symptom.code === this.getSelectedMainSymptomCode;
                            });

                            if (this.shortcutNav.crtSymptom === null && mainSymptomInSubchapter < 0) {
                                this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[0].code;
                            }
                            else if (this.shortcutNav.crtSymptom === null && mainSymptomInSubchapter >= 0) {
                                this.shortcutNav.crtSymptom = this.getSelectedMainSymptomCode;
                            }
                            this.navScrollIntoSymptomPanelWithSubchapters();
                        }
                        break;

                    case CMS_PANEL.SYMPTOM:
                        if (this.getActiveChapter && !this.getHasSubchapters) {

                            let mainSymptomInChapter = this.getActiveChapter.symptoms.findIndex((symptom) => {
                                return symptom.code === this.getSelectedMainSymptomCode;
                            });

                            if (this.shortcutNav.crtSymptom === null && mainSymptomInChapter < 0) {
                                this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[0].code;
                            }
                            else if (this.shortcutNav.crtSymptom === null && mainSymptomInChapter >= 0) {
                                this.shortcutNav.crtSymptom = this.getSelectedMainSymptomCode;
                            }

                           this.navScrollIntoSymptomsPanelWithoutSubchapters();
                        }
                        break;

                    case CMS_PANEL.SEARCH:
                        // we need to scroll down to the current symptom from search result panel
                        if (this.getSearchSymptomResultList.length && this.shortcutNav.crtSymptom != null) {
                            this.navScrollIntoSymptomsSearchPanel();
                        }
                        break;
                }
            },

            navChapterDown() {

                let visibleChaptersList = [];

                if (this.getChapterTree.chapters != null && this.getChapterTree.chapters.length > 0) {
                    visibleChaptersList = this.getChapterTree.chapters.filter(this.navIsChapterVisible);
                }

                if (!visibleChaptersList.length) {
                    return;
                }

                if (this.shortcutNav.crtChapter === null) {
                    this.shortcutNav.crtChapter = visibleChaptersList[0].code;
                }
                else {
                    let chapterIdx = visibleChaptersList.findIndex((crtChapter) => {
                        return (crtChapter.code === this.shortcutNav.crtChapter);
                    });

                    let chapterLength = visibleChaptersList.length - 1;

                    if (chapterIdx < 0 || chapterIdx === chapterLength) {
                        this.shortcutNav.crtChapter = visibleChaptersList[0].code;
                    }
                    else {
                        this.shortcutNav.crtChapter = visibleChaptersList[chapterIdx + 1].code;
                    }
                }
            },

            navChapterUp() {

                let visibleChaptersList = [];

                if (this.getChapterTree.chapters != null && this.getChapterTree.chapters.length > 0) {
                    visibleChaptersList = this.getChapterTree.chapters.filter(this.navIsChapterVisible);
                }

                if (!visibleChaptersList.length) {
                    return;
                }

                if (this.shortcutNav.crtChapter === null) {
                    this.shortcutNav.crtChapter = visibleChaptersList[0].code;
                }
                else {
                    let chapterIdx = visibleChaptersList.findIndex((crtChapter) => {
                        return (crtChapter.code === this.shortcutNav.crtChapter);
                    });

                    if (chapterIdx < 0) {
                        this.shortcutNav.crtChapter = visibleChaptersList[0].code;
                    }
                    else if (chapterIdx === 0) {
                        this.shortcutNav.crtChapter = visibleChaptersList[visibleChaptersList.length - 1].code;
                    }
                    else {
                        this.shortcutNav.crtChapter = visibleChaptersList[chapterIdx - 1].code;
                    }
                }
            },

            navToFirstVisibleChapter() {

                if (this.getChapterTree.chapters != null && this.getChapterTree.chapters.length > 0) {

                    let visibleChaptersList = this.getChapterTree.chapters.filter(this.navIsChapterVisible);
                    if (visibleChaptersList.length > 0) {
                        this.shortcutNav.crtChapter = visibleChaptersList[0].code;
                    }
                }
            },

            navToLastVisibleChapter() {

                if (this.getChapterTree.chapters != null && this.getChapterTree.chapters.length > 0) {

                    let visibleChaptersList = this.getChapterTree.chapters.filter(this.navIsChapterVisible);
                    let lastIdx = visibleChaptersList.length - 1;
                    if (lastIdx >= 0) {
                        this.shortcutNav.crtChapter = visibleChaptersList[lastIdx].code;
                    }
                }
            },

            navIsChapterVisible(crtChapter) {

                return ((crtChapter.subChapters && crtChapter.subChapters.length > 0)
                    || (crtChapter.symptoms && crtChapter.symptoms.length > 0));
            },

            navFromChapterToNextPanel(isXsAndDown, isLast, isCtrlKeyPressed) {

                if (this.getActiveChapter) {

                    if (this.getHasSubchapters) {

                        if (isXsAndDown) {
                            this.shortcutNav.crtPanel = CMS_PANEL.SUBCHAPTER;

                            if (isLast) {
                                let lastSubchapterIdx = this.getActiveChapter.subChapters.length - 1;
                                this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[lastSubchapterIdx].code;
                            }
                            else {
                                this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                            }
                            this.navScrollIntoViewSubchapterPanel();
                        }
                        else {
                            // Ctrl + Shift + Arrow Right or Shift + Arrow Right -> move from chapter to first subchapter
                            if (!isCtrlKeyPressed || (isCtrlKeyPressed && isLast)) {
                                this.shortcutNav.crtPanel = CMS_PANEL.SUBCHAPTER;
                                this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                            }
                        }
                    }
                    else {

                        if (isXsAndDown) {
                            this.shortcutNav.crtPanel = CMS_PANEL.SYMPTOM;
                            this.navScrollIntoViewSymptomPanel();
                        }
                        else {
                            if (!isCtrlKeyPressed || (isCtrlKeyPressed && isLast)) {
                                this.shortcutNav.crtPanel = CMS_PANEL.SYMPTOM;
                            }
                        }
                    }
                }
                else {
                    // move from Chapter panel -> Search Panel (search field text is not empty)
                    if (this.getSearchSymptomResultList != null && this.getSearchSymptomResultList.length > 0
                        && this.$refs["chaptersRef"] != null && this.$refs["chaptersRef"].searchSymptomInputValue !== "") {

                        if (isXsAndDown) {
                            this.shortcutNav.crtPanel = CMS_PANEL.SEARCH;
                            this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;

                            this.navScrollIntoViewSearchPanel();
                        }
                        else {
                            if (!isCtrlKeyPressed || (isCtrlKeyPressed && isLast)) {
                                this.shortcutNav.crtPanel = CMS_PANEL.SEARCH;
                                this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;
                            }
                        }
                    }
                }
            },

            navSubchapterDown(isXsAndDown) {

                if (this.getActiveChapter && this.getHasSubchapters) {

                    if (this.shortcutNav.crtSubchapter === null) {
                        this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                        this.navScrollIntoViewSubchapterPanel();

                    }
                    else {
                        let subchapterIdx = this.getActiveChapter.subChapters.findIndex((crtSubchapter) => {
                            return crtSubchapter.code === this.shortcutNav.crtSubchapter;
                        });

                        if (subchapterIdx < 0) {
                            this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                            this.navScrollIntoViewSubchapterPanel();
                        }
                        else if (subchapterIdx === (this.getActiveChapter.subChapters.length - 1)) {

                            if (isXsAndDown) {
                                this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                                this.navScrollToTopChapterPanel();
                            }
                            else {
                                this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                                this.navScrollIntoViewSubchapterPanel();
                            }
                        }
                        else {
                            this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[subchapterIdx + 1].code;
                            this.navScrollIntoViewSubchapterPanel();
                        }
                    }
                }
            },

            navSubchapterUp(isXsAndDown) {

                if (this.getActiveChapter && this.getHasSubchapters) {

                    if (this.shortcutNav.crtSubchapter === null) {

                        this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                        this.navScrollIntoViewSubchapterPanel();
                    }
                    else {
                        let subchapterIdx = this.getActiveChapter.subChapters.findIndex((crtSubchapter) => {
                            return crtSubchapter.code === this.shortcutNav.crtSubchapter;
                        });

                        if (subchapterIdx < 0) {
                            this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                            this.navScrollIntoViewSubchapterPanel();
                        }
                        else if (subchapterIdx === 0) {

                            if (isXsAndDown) {
                                this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                                this.navScrollToTopChapterPanel();
                            }
                            else {
                                this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[this.getActiveChapter.subChapters.length - 1].code;
                                this.navScrollIntoViewSubchapterPanel();
                            }
                        }
                        else {
                            this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[subchapterIdx - 1].code;
                            this.navScrollIntoViewSubchapterPanel();
                        }
                    }
                }
            },

            navToFirstSubchapter() {

                if (this.getActiveChapter && this.getHasSubchapters) {
                    this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[0].code;
                }
            },

            navToLastSubchapter() {

                if (this.getActiveChapter && this.getHasSubchapters) {

                    let subchapterIdx = this.getActiveChapter.subChapters.length - 1;
                    if (subchapterIdx >= 0) {
                        this.shortcutNav.crtSubchapter = this.getActiveChapter.subChapters[subchapterIdx].code;
                    }
                }
            },

            navSymptomDown() {

                if (this.getActiveChapter && this.getHasSubchapters) {

                    let subchapterIdx = this.getActiveChapter.subChapters.findIndex((crtSubchapter) => {
                        return crtSubchapter.code === this.shortcutNav.crtSubchapter;
                    });

                    if (subchapterIdx >= 0) {

                        if (this.shortcutNav.crtSymptom === null) {
                            this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[0].code;
                        }
                        else {
                            let symptomIdx = this.getActiveChapter.subChapters[subchapterIdx].symptoms.findIndex((crtSymptom) => {
                                return crtSymptom.code === this.shortcutNav.crtSymptom;
                            });

                            if (symptomIdx < 0 || symptomIdx === (this.getActiveChapter.subChapters[subchapterIdx].symptoms.length - 1)) {
                                this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[0].code;
                            }
                            else {
                                this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[symptomIdx + 1].code;
                            }
                        }
                        this.navScrollIntoSymptomPanelWithSubchapters();
                    }
                }
                else if (this.getActiveChapter && !this.getHasSubchapters) {

                    if (this.shortcutNav.crtSymptom === null) {
                        this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[0].code;
                    }
                    else {
                        let symptomIdx = this.getActiveChapter.symptoms.findIndex((crtSymptom) => {
                            return crtSymptom.code === this.shortcutNav.crtSymptom;
                        });

                        if (symptomIdx < 0 || symptomIdx === this.getActiveChapter.symptoms.length - 1) {
                            this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[0].code;
                        }
                        else {
                            this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[symptomIdx + 1].code;
                        }
                    }
                    this.navScrollIntoSymptomsPanelWithoutSubchapters();
                }
            },

            navSymptomUp() {

                if (this.getActiveChapter && this.getHasSubchapters) {

                    let subchapterIdx = this.getActiveChapter.subChapters.findIndex((crtSubchapter) => {
                        return crtSubchapter.code === this.shortcutNav.crtSubchapter;
                    });

                    if (subchapterIdx >= 0) {

                        if (this.shortcutNav.crtSymptom === null) {
                            this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[0].code;
                        }
                        else {
                            let symptomIdx = this.getActiveChapter.subChapters[subchapterIdx].symptoms.findIndex((crtSymptom) => {
                                return crtSymptom.code === this.shortcutNav.crtSymptom;
                            });

                            if (symptomIdx < 0) {
                                this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[0].code;
                            }
                            else if (symptomIdx === 0) {
                                let symptomLength = this.getActiveChapter.subChapters[subchapterIdx].symptoms.length;
                                this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[symptomLength - 1].code;
                            }
                            else {
                                this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[symptomIdx - 1].code;
                            }
                        }
                        this.navScrollIntoSymptomPanelWithSubchapters();
                    }
                }
                else if (this.getActiveChapter && !this.getHasSubchapters) {

                    if (this.shortcutNav.crtSymptom === null) {
                        this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[0].code;
                    }
                    else {
                        let symptomIdx = this.getActiveChapter.symptoms.findIndex((crtSymptom) => {
                            return crtSymptom.code === this.shortcutNav.crtSymptom;
                        });

                        if (symptomIdx < 0) {
                            this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[0].code;
                        }
                        else if (symptomIdx === 0) {
                            let symptomLength = this.getActiveChapter.symptoms.length;
                            this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[symptomLength - 1].code;
                        }
                        else {
                            this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[symptomIdx - 1].code;
                        }
                    }
                    this.navScrollIntoSymptomsPanelWithoutSubchapters();
                }
            },

            navToFirstSymptom() {

                if (this.getActiveChapter && this.getHasSubchapters) {

                    let subchapterIdx = this.getActiveChapter.subChapters.findIndex((crtSubchapter) => {
                        return crtSubchapter.code === this.shortcutNav.crtSubchapter;
                    });

                    if (subchapterIdx >= 0) {
                        this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[0].code;
                        this.navScrollIntoSymptomPanelWithSubchapters();
                    }
                }
                else if (this.getActiveChapter && !this.getHasSubchapters) {

                    this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[0].code;
                    this.navScrollIntoSymptomsPanelWithoutSubchapters();
                }
            },

            navToLastSymptom() {

                if (this.getActiveChapter && this.getHasSubchapters) {

                    let subchapterIdx = this.getActiveChapter.subChapters.findIndex((crtSubchapter) => {
                        return crtSubchapter.code === this.shortcutNav.crtSubchapter;
                    });

                    if (subchapterIdx >= 0) {

                        let symptomIdx = this.getActiveChapter.subChapters[subchapterIdx].symptoms.length - 1;
                        this.shortcutNav.crtSymptom = this.getActiveChapter.subChapters[subchapterIdx].symptoms[symptomIdx].code;
                        this.navScrollIntoSymptomPanelWithSubchapters();
                    }
                }
                else if (this.getActiveChapter && !this.getHasSubchapters) {

                    let symptomIdx = this.getActiveChapter.symptoms.length - 1;
                    this.shortcutNav.crtSymptom = this.getActiveChapter.symptoms[symptomIdx].code;
                    this.navScrollIntoSymptomsPanelWithoutSubchapters();
                }
            },

            navSymptomSearchDown() {

                if (this.getSearchSymptomResultList != null && this.getSearchSymptomResultList.length > 0) {

                    if (this.shortcutNav.crtSymptom === null) {
                        this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;
                    }
                    else {
                        let symptomSearchIdx = this.getSearchSymptomResultList.findIndex((crtSymptomSearch) => {
                            return crtSymptomSearch.code === this.shortcutNav.crtSymptom;
                        });

                        if (symptomSearchIdx < 0 || symptomSearchIdx === this.getSearchSymptomResultList.length - 1) {
                            this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;
                        }
                        else {
                            this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[symptomSearchIdx + 1].code;
                        }
                    }
                }
            },

            navSymptomSearchUp() {

                if (this.getSearchSymptomResultList != null && this.getSearchSymptomResultList.length > 0) {

                    if (this.shortcutNav.crtSymptom === null) {
                        this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;
                    }
                    else {
                        let symptomSearchIdx = this.getSearchSymptomResultList.findIndex((crtSymptomSearch) => {
                            return crtSymptomSearch.code === this.shortcutNav.crtSymptom;
                        });

                        if (symptomSearchIdx < 0) {
                            this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;
                        }
                        else if (symptomSearchIdx === 0) {
                            let symptomSearchLength = this.getSearchSymptomResultList.length;
                            this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[symptomSearchLength - 1].code;
                        }
                        else {
                            this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[symptomSearchIdx - 1].code;
                        }
                    }
                }
            },

            navToFirstSymptomSearch() {

                if (this.getSearchSymptomResultList != null && this.getSearchSymptomResultList.length > 0) {
                    this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;
                }
            },

            navToLastSymptomSearch() {

                if (this.getSearchSymptomResultList != null && this.getSearchSymptomResultList.length > 0) {

                    let symptomSearchIdx = this.getSearchSymptomResultList.length - 1;
                    this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[symptomSearchIdx].code;
                }
            },

            navSelectMainSymptom() {

                if (this.shortcutNav.crtSymptom !== null) {
                    this.$store.commit('ChooseMainSymptomStore/setSelectedMainSymptomCode', this.shortcutNav.crtSymptom);
                }
            },

            navGotoFirstPage() {
                if(!this.getMustShowAssessmentList) {
                    this.$router.push('/assessment-start');
                } else {
                    this.$router.push('/assessment-start-list');
                }
            },

            navFocusOnSearchSymptom() {

                // if we have search result and in keyboard navigation, we put highlight on first symptom
                if (this.shortcutNav.isKeyboardNav && this.getSearchSymptomResultList != null) {

                    if (this.getSearchSymptomResultList.length > 0) {

                        this.shortcutNav.crtPanel = CMS_PANEL.SEARCH;
                        this.shortcutNav.crtSymptom = this.getSearchSymptomResultList[0].code;
                    }
                    else if (this.getSearchSymptomResultList.length === 0) {

                        this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                        this.shortcutNav.crtSymptom = null;
                    }
                }
                else if (!this.shortcutNav.isKeyboardNav && this.getSearchSymptomResultList != null) {
                    // set panel for keyboard navigation when needed and reset crtSymptom
                    this.shortcutNav.crtPanel = CMS_PANEL.SEARCH;
                    this.shortcutNav.crtSymptom = null;
                }
            },

            navSetFocusAndScrollToElement(newValue) {

                if (this.shortcutNav.isKeyboardNav === true && newValue === false) {

                    this.navSetFocusAndScrollToCrtElem();
                }
                else if (this.shortcutNav.isKeyboardNav === false && newValue === false) {

                    this.navSetFocusAndScrollToCrtPos();
                }
            },

            navSetFocusOnSearchInput() {

                if (this.$refs["chaptersRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].isFocused === false) {

                    this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].focus();
                }
            },


            navSetFocusAndScrollToCrtElem() {

                if (this.$refs["chaptersRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].isFocused === false) {

                    this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].focus();

                    // scroll to the selected element after focus on search input
                    let that = this;
                    setTimeout(() => {
                        that.navScrollIntoViewPanels();
                    }, 0);
                }
            },

            navSetFocusAndScrollToCrtPos() {

                if (this.$refs["chaptersRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].isFocused === false
                    && this.$refs["mainSymptomScrollingContentRef"] != null
                    && this.$refs["mainSymptomScrollingContentRef"].scrollTop != null) {

                        // select the current scroll position
                        let scrollTop = this.$refs["mainSymptomScrollingContentRef"].scrollTop;

                        this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].focus();

                        // scroll to the selected scroll position after focus on search input
                        let that = this;
                        setTimeout(() => {
                            that.$refs["mainSymptomScrollingContentRef"].scrollTop = scrollTop;
                        },0);
                }
            },

            navSetBlurOnSearchInput() {

                if (this.$refs["chaptersRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"] != null
                    && this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].isFocused === true) {

                    this.$refs["chaptersRef"].$refs["inputSearchSymptomRef"].blur();
                }
            },

            navToPreviousOrRightPanel(isXsAndDown, isCtrlKeyPressed) {

                switch (this.shortcutNav.crtPanel) {

                    case CMS_PANEL.CHAPTER:
                        this.navFromChapterToNextPanel(isXsAndDown, true, isCtrlKeyPressed);
                        break;

                    case CMS_PANEL.SUBCHAPTER:
                        if (isXsAndDown) {
                            this.navSubchapterUp(isXsAndDown);
                        }
                        else {
                            if (!isCtrlKeyPressed) {
                                this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                                this.navScrollToTopChapterPanel();
                            }
                        }
                        break;

                    case CMS_PANEL.SYMPTOM:
                        if (!this.getHasSubchapters) {

                            if (!isCtrlKeyPressed) {
                                this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                                this.navScrollToTopChapterPanel();
                            }
                        }
                        break;

                }
            },

            navToNextOrLeftPanel(isXsAndDown, isCtrlKeyPressed) {

                switch (this.shortcutNav.crtPanel) {

                    case CMS_PANEL.CHAPTER:
                        // for circular shortcut navigation
                        this.navFromChapterToNextPanel(isXsAndDown, false, isCtrlKeyPressed);
                        break;

                    case CMS_PANEL.SUBCHAPTER:
                        if (isXsAndDown) {
                            this.navSubchapterDown(isXsAndDown);
                        }
                        else {
                            this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                            this.navScrollToTopChapterPanel();
                        }
                        break;

                    case CMS_PANEL.SYMPTOM:
                        // if we don't have subchapters, we need to scroll up to top of the chapter panel
                        if (!this.getHasSubchapters) {
                            this.shortcutNav.crtPanel = CMS_PANEL.CHAPTER;
                            this.navScrollToTopChapterPanel();
                        }
                        break;
                }
            },

            navScrollIntoViewChapterPanel() {

                let chapterPanel = document.querySelector('#CHAPTER_' + this.shortcutNav.crtChapter);
                if (chapterPanel != null) {

                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = chapterPanel.offsetTop - 100;
                }
            },

            navScrollToTopChapterPanel() {

                let chapterPanel = document.querySelector('#vListChaptersId');
                if (chapterPanel != null) {

                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = chapterPanel.offsetTop - 100;
                }
            },

            navScrollIntoViewSubchapterPanel() {

                if (this.$refs["symptomsRef"] != null
                    && this.$refs["symptomsRef"].$refs['vExpansionPanelContentSubchapterRef_' + this.shortcutNav.crtSubchapter] != null
                    && this.$refs["symptomsRef"].$refs['vExpansionPanelContentSubchapterRef_' + this.shortcutNav.crtSubchapter][0] != null) {

                    let subchapterPanel = this.$refs["symptomsRef"].$refs['vExpansionPanelContentSubchapterRef_' + this.shortcutNav.crtSubchapter][0];
                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = subchapterPanel.$el.offsetTop - 100;
                }
            },

            navScrollIntoViewSymptomPanel() {

                if (this.$refs["symptomsRef"] != null
                    && this.$refs["symptomsRef"].$refs["vCardSymptomPanelRef"] != null) {

                    let symptomPanel = this.$refs["symptomsRef"].$refs["vCardSymptomPanelRef"];
                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = symptomPanel.$el.offsetTop - 80;
                }
            },

            navScrollIntoSymptomsPanelWithoutSubchapters() {

                if (this.$refs["symptomsRef"] != null
                    && this.$refs["symptomsRef"].$refs["vCardSymptomPanelRef"] != null
                    && this.$refs["symptomsRef"].$refs['vRadioSymptomsWithoutSubchaptersRef_' + this.shortcutNav.crtSymptom] != null
                    && this.$refs["symptomsRef"].$refs['vRadioSymptomsWithoutSubchaptersRef_' + this.shortcutNav.crtSymptom][0] != null) {

                    let radioSymptomPanel = this.$refs["symptomsRef"].$refs['vRadioSymptomsWithoutSubchaptersRef_' + this.shortcutNav.crtSymptom][0];
                    let symptomPanel = this.$refs["symptomsRef"].$refs["vCardSymptomPanelRef"];

                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = symptomPanel.$el.offsetTop + radioSymptomPanel.$el.offsetTop - 100;
                }
            },

            navScrollIntoSymptomPanelWithSubchapters() {

                let containerScrollable = document.querySelector('.scrolling-content');

                if (this.$refs["symptomsRef"] != null
                    && this.$refs["symptomsRef"].$refs['vRadioSymptomsWithSubchaptersRef_' + this.shortcutNav.crtSymptom] != null
                    && this.$refs["symptomsRef"].$refs['vRadioSymptomsWithSubchaptersRef_' + this.shortcutNav.crtSymptom][0] != null) {

                    this.symptomsPanelRef = this.$refs["symptomsRef"].$refs['vRadioSymptomsWithSubchaptersRef_' + this.shortcutNav.crtSymptom][0];

                    if (this.symptomsPanelRef.$parent != null
                        && this.symptomsPanelRef.$parent.$parent != null
                        && this.symptomsPanelRef.$parent.$parent.$parent != null
                        && this.symptomsPanelRef.$parent.$parent.$parent.$el.offsetTop != null) {

                        containerScrollable.scrollTop = this.symptomsPanelRef.$parent.$parent.$parent.$el.offsetTop + this.symptomsPanelRef.$el.offsetTop - 100;
                    }
                }
            },

            navScrollIntoSymptomsSearchPanel() {

                if (this.$refs["chaptersRef"] != null
                    && this.$refs["chaptersRef"].$refs["vCardSearchResultRef"] != null
                    && this.$refs["chaptersRef"].$refs['vRadioSymptomsSearchRef_' + this.shortcutNav.crtSymptom] != null
                    && this.$refs["chaptersRef"].$refs['vRadioSymptomsSearchRef_' + this.shortcutNav.crtSymptom][0] != null) {

                    let searchPanel = this.$refs["chaptersRef"].$refs["vCardSearchResultRef"];
                    let radioSearchSymptom = this.$refs["chaptersRef"].$refs['vRadioSymptomsSearchRef_' + this.shortcutNav.crtSymptom][0];

                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = searchPanel.$el.offsetTop + radioSearchSymptom.$el.offsetTop - 100;
                }
            },

            navScrollIntoViewSearchPanel() {

                if (this.$refs["chaptersRef"] != null
                    && this.$refs["chaptersRef"].$refs["vCardSearchResultRef"] != null) {

                    let searchResultPanel = this.$refs["chaptersRef"].$refs["vCardSearchResultRef"];
                    let containerScrollable = document.querySelector('.scrolling-content');
                    containerScrollable.scrollTop = searchResultPanel.$el.offsetTop - 130;
                }

            },

            navScrollIntoViewPanels() {

                switch (this.shortcutNav.crtPanel) {

                    case CMS_PANEL.CHAPTER:
                        if (this.getActiveChapter) {
                            this.navScrollIntoViewChapterPanel();
                        }
                        else {
                            this.navScrollToTopChapterPanel();
                        }
                        break;

                    case CMS_PANEL.SUBCHAPTER:
                        this.navScrollIntoViewSubchapterPanel();
                        break;

                    case CMS_PANEL.SYMPTOM:
                        if (this.getHasSubchapters) {
                            this.navScrollIntoSymptomPanelWithSubchapters();
                        }
                        else {
                            this.navScrollIntoSymptomsPanelWithoutSubchapters();
                        }
                        break;

                    case CMS_PANEL.SEARCH:
                        if (this.getSearchSymptomResultList && this.getSearchSymptomResultList.length > 0) {
                            this.navScrollIntoSymptomsSearchPanel();
                        }
                        else {
                            this.navScrollIntoViewSearchPanel();
                        }
                        break;
                }
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .expansion-panel__header {
        padding-bottom: 20px;
        padding-top: 20px;
    }

    .container.grid-list-xl.main-symptom-container .layout.page-content {
        margin-top: 0;
    }

    .alerts-top {
        display: inline-flex;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/choose-main-symptom/ChooseMainSymptomPage.vue